$(document).ready(function() {
    var isFirstLoad = true;

    // Función para manejar el cambio de pestañas
    function handleTabs($tabsContainer) {
        $tabsContainer.find('.tabs-vertical__header-element').click(function() {
            var tabId = $(this).data('tab');

            // Ocultar todos los contenidos de las pestañas y remover la clase 'active'
            $tabsContainer.find('.tabs-vertical__container-element').removeClass('active').hide();

            // Mostrar el contenido de la pestaña seleccionada y agregar la clase 'active'
            $tabsContainer.find('.tabs-vertical__container-element[data-tab="' + tabId + '"]').addClass('active').fadeIn();

            // Remover la clase 'active' de todas las pestañas y agregarla a la pestaña seleccionada
            $tabsContainer.find('.tabs-vertical__header-element').removeClass('active');
            $(this).addClass('active');

            // Desplazar la página para enfocar el contenido de la pestaña abierta solo si no es la primera carga
            if (!isFirstLoad) {
                $('html, body').animate({
                    scrollTop: $tabsContainer.offset().top - 200
                }, 300);
            }
        });

        // Abrir la primera pestaña por defecto sin desplazamiento
        var firstTab = $tabsContainer.find('.tabs-vertical__header-element[data-tab="1"]');

        // Mostrar la primera pestaña sin hacer scroll
        $tabsContainer.find('.tabs-vertical__container-element').removeClass('active').hide();
        $tabsContainer.find('.tabs-vertical__container-element[data-tab="1"]').addClass('active').fadeIn();
        $tabsContainer.find('.tabs-vertical__header-element').removeClass('active');
        firstTab.addClass('active');
    }

    // Llamar a la función para cada contenedor de pestañas
    handleTabs($('.tabs-vertical').eq(0)); // Primer bloque de pestañas
    handleTabs($('.tabs-vertical').eq(1)); // Segundo bloque de pestañas

    // Marcar que la primera carga ya ha ocurrido
    isFirstLoad = false;
});
